export const useSurveySparrowWebAPI = () => {
	const getData = async (url) => {
		return fetch(process.env.REACT_APP_SURVEYSPARROW_SURVEY_URL + url, {
			method: "GET",
			headers: {
				Authorization: "Bearer " + process.env.REACT_APP_SURVEYSPARROW_API_TOKEN
			}
		})
	}

	const postData = async (url, data) => {
		return fetch(process.env.REACT_APP_SURVEYSPARROW_SURVEY_URL + url, {
			method: "POST",
			headers: {
				"Authorization": "Bearer " + process.env.REACT_APP_SURVEYSPARROW_API_TOKEN,
				"Content-Type": "application/json"
			},
			body: JSON.stringify(data)
		})
	}

	return { getData, postData }
}
